import { getPublicSiteLabel } from "./public-web";

type Translator = (key: string, options?: Record<string, unknown>) => string;

export interface UsernameChange {
  from: string;
  to: string;
}

/**
 * Copy for the "change your username?" confirmation. A rename frees the old
 * handle at once and nothing redirects it, so the dialog names both links.
 * Keys live in the `common` namespace (settings.accountEdit.*).
 */
export function getUsernameChangeConfirmationCopy(
  t: Translator,
  { from, to }: UsernameChange,
) {
  const site = getPublicSiteLabel() || "tabbio.com";
  return {
    title: t("settings.accountEdit.usernameConfirmTitle"),
    message: t("settings.accountEdit.usernameConfirmMessage", {
      oldLink: `${from}.${site}`,
      newLink: `${to}.${site}`,
    }),
    confirm: t("settings.accountEdit.usernameConfirmAction"),
    cancel: t("settings.accountEdit.usernameConfirmCancel"),
  };
}
